import type { Dayjs } from 'dayjs';

interface UseDocumentExpirationLabelProps {
  expiryDate: Dayjs;
}

type DocumentExpirationLabelState =
  | {
      hasExpirationDate: false;
      formattedDate: null;
    }
  | {
      hasExpirationDate: true;
      formattedDate: string;
    };

export const useDocumentExpirationLabel = ({ expiryDate }: UseDocumentExpirationLabelProps): DocumentExpirationLabelState => {
  if (!expiryDate.isValid()) {
    return { hasExpirationDate: false, formattedDate: null };
  }

  return {
    hasExpirationDate: true,
    formattedDate: expiryDate.format('MMMM D, YYYY'),
  };
};
